/*
 * Author: Nano PMS Fixing
 * Title: Duplicate UID Fixing Page
 * Description: Wrapper for duplicate code_no fixing — only via direct URL, fixing group
 * Date: 2026-09-09
 */
import { DuplicateUidProvider } from '../duplicateUidFixing/ContextAPI';
import Index from '../duplicateUidFixing/Index';

export default function DuplicateUidFixing() {
    return (
        <DuplicateUidProvider>
            <Index />
        </DuplicateUidProvider>
    );
}
